<template>
  <v-card
    :ripple="false"
    class="contract-card main-contract-card"
     v-if="!expanded"
  >
    <v-card-text>
      <v-row class="text--secondary" dense>
        <v-col>
          <small> {{ $t('contract.name') }} </small>
          <p><b>{{contract.contractName}}</b></p>
        </v-col>
        <v-col>
          <small> {{ $tc(`contract.project.${contract.area.code || 'OFF'}`, 1) }} </small>
          <p class="text--secondary"><b>{{projectName}}</b></p>
        </v-col>
        <v-btn
          icon
          @click="$emit(expanded ? 'COLLAPSE' : 'EXPAND')"
          class="mt-2 mr-1 mb-1"
        >
          <v-icon>{{expanded ? 'mdi-arrow-collapse' : 'mdi-arrow-expand'}}</v-icon>
        </v-btn>
      </v-row>
    </v-card-text>
    <v-card-text class="pt-0">
      <v-row justify="start" align="start">
        <v-col>
          <v-btn
            x-small
            rounded
            dark
            color="primary"
            :outlined="!showVariations"
            @click.stop="showVariations = true"
            :style="{ marginLeft: '0px' }"
          >
            {{ $t('contract.stats.variations') }}
          </v-btn>
          <v-btn
            x-small
            rounded
            dark
            color="primary"
            :outlined="showVariations"
            @click.stop="showVariations = false"
          >
            {{ $t('contract.stats.payments') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="showVariations">
        <v-col
          cols="6"
          v-for="(group, index) in pieChartData"
          :key="index"
        >
          <chart-pie
            :headline="group.headline"
            :items="group.data"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="!showVariations"
        justify="end"
        align-content="end"
        :style="{
          margin: '10px 0'
        }"
      >
        <v-btn
          x-small
          rounded
          dark
          color="primary"
          :outlined="!showAdjusted"
          @click.stop="showAdjusted = true"
        >
          {{ $t('contract.stats.adjusted') }}
        </v-btn>
        <v-btn
          x-small
          rounded
          dark
          color="primary"
          :outlined="showAdjusted"
          @click.stop="showAdjusted = false"
        >
          {{ $t('contract.stats.forecasted') }}
        </v-btn>
      </v-row>
      <v-row v-if="!showVariations">
        <v-row v-if="showAdjusted">
          <v-col :col=15>
            <chart-bars
              v-for="(block, index) in adjustedBarsData"
              :key="index"
              :type="block.type"
              :entry="block"
              :labels="block.labels"
              color="primary"
            />
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col :col=15>
            <chart-bars
              v-for="(block, index) in forecastedBarsData"
              :key="index"
              :type="block.type"
              :entry="block"
              :labels="block.labels"
              color="primary"
            />
          </v-col>
        </v-row>
      </v-row>
    </v-card-text>
    <v-card-text>
      <v-row class="justify-center align-center mb-3">
        <v-btn
          v-for="subContract in contract.subContracts"
          :key="subContract.id"
          rounded
          dense
          x-small
          outlined
          color="primary"
          @click="handleContractClick(subContract)"
          class="mt-1"
        >
          {{ $t('contract.selectName', { name: subContract.contractName }) }}
        </v-btn>
      </v-row>
      <v-row class="justify-center align-center pt-2 pb-2">
        <v-btn
          rounded
          dark
          dense
          color="primary"
          @click="handleContractClick(contract)"
          class="ma-1"
        >
          {{ $t('contract.selectThis') }}
        </v-btn>
      </v-row>
    </v-card-text>
  </v-card>
  <v-card v-else :style="{ height: '100%' }" class="pa-3 contract-card expanded-main-contract-card">
    <v-row dense align="center">
      <v-col class="pb-0 mx-2 mt-2" cols="4">
        <small> {{ $t('contract.name') }} </small>
        <p class="text--secondary"><b>{{contract.contractName}}</b></p>
      </v-col>
      <v-col class="pb-0 mx-2 mt-2" cols="5">
        <small> {{ $tc(`contract.project.${contract.area.code || 'OFF'}`, 1) }} </small>
        <p class="text--secondary"><b>{{projectName}}</b></p>
      </v-col>
      <v-spacer />
      <v-btn
        icon
        @click="$emit(expanded ? 'COLLAPSE' : 'EXPAND')"
        class="mr-2"
      >
        <v-icon>{{expanded ? 'mdi-arrow-collapse' : 'mdi-arrow-expand'}}</v-icon>
      </v-btn>
    </v-row>
    <v-row>
      <v-col
        v-for="(subContract, index) in contract.subContracts"
        :key="index"
        cols="12"
        :md="subContractColsSize.md"
        :lg="subContractColsSize.lg"
        :xl="subContractColsSize.xl"
        class="pt-0"
      >
        <contract-card :contract="subContract" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ColorsMixin from '@/mixins/ColorsMixin'
import ContractCardMixin from '@/mixins/ContractCardMixin'

export default {
  name: 'MainContractCard',
  props: {
    contract: {
      type: Object,
      default: () => ({})
    },
    expanded: {
      type: Boolean
    }
  },
  mixins: [ColorsMixin, ContractCardMixin],
  data () {
    return { }
  },
  computed: {
    projectName () {
      return this.contract.project
        ? `${this.contract.project.name} ${this.contract.project.code ? `- ${this.contract.project.code}` : ''}`
        : ''
    },
    subContractColsSize () {
      if (this.contract.subContracts.length > 2) {
        return { md: 6, lg: 4, xl: 4 }
      } else if (this.contract.subContracts.length === 2) {
        return { md: 6, lg: 6, xl: 6 }
      }
      return { md: 12, lg: 12, xl: 12 }
    }
  }
}
</script>

<style>
.main-contract-card,
.main-contract-card .v-sheet{
  background-color: #f0faff !important;
}
.expanded-main-contract-card {
  background-color: #f0faff !important;
}
</style>
